import { Directive } from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[numbers]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NumberPatternDirective, multi: true }]
})
export class NumberPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.numberPatternValidator()(control);
  }

}
